module.exports = __webpack_public_path__ + "img/tintuc24.387b4c4b.png";